export function getUserInitials(firstName: string = '', lastName: string = '') {
  return `${[
    ...firstName,
  ][0] || ''}${[
    ...lastName,
  ][0] || ''}`;
}
